import PubSub from "underpub-js";

var Header = function (options) {

  this.options = {
    $el: false,
    baseClass: 'mol-Header',
  };

  $.extend(true, this.options, options);

};

Header.prototype.init = function () {

  var self = this;

  self.$hamburger = self.options.$el.find(
    `.${self.options.baseClass}__hamburger`,
  );

  self.$hamburger.on('click', () => {
    PubSub.publish('NavigationPopup__toggle');
  });

};

export default Header;